import ServiceDetailLayout from '../components/ServiceDetailLayout';
import { serviceDetails } from '@/mocks/service-details';

export default function DeepCleaningPage() {
  return <ServiceDetailLayout data={serviceDetails['deep-cleaning']} />;
}